/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GraphionScoreRangeQueryOperator extends models.AppSecopsScoreRangeQueryOperator {
    constructor() {
        super();
        this.setDiscriminator("GraphionScoreRangeQueryOperator");
    }

    getFixupPrototypeFunction() { return GraphionScoreRangeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<GraphionScoreRangeQueryOperator>): GraphionScoreRangeQueryOperator {
        let obj = Object.assign(new GraphionScoreRangeQueryOperator(), model);
        GraphionScoreRangeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GraphionScoreRangeQueryOperator>): GraphionScoreRangeQueryOperator {
        if (!model) return null;
        return GraphionScoreRangeQueryOperator.newInstance(<GraphionScoreRangeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GraphionScoreRangeQueryOperator) {
        if (!obj) return;

        models.GraphionScoreRangeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GraphionScoreRangeQueryOperator): boolean {
        if (models.AppSecopsScoreRangeQueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GraphionScoreRangeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
